export default __webpack_public_path__ + "static/media/avatar2.5692c39d.png";